import { Building2 } from 'lucide-react';

const PARTNERS = [
  'Commercial Bank of Ethiopia', 'Awash Bank', 'Dashen Bank', 'Bank of Abyssinia',
  'Zemen Bank', 'Hibret Bank', 'Cooperative Bank', 'Wegagen Bank',
  'Ethio Telecom', 'Safaricom Ethiopia', 'Ethiopian Airlines', 'CCECC',
];

export function PartnersSection() {
  const items = [...PARTNERS, ...PARTNERS]; // duplicate for marquee loop
  return (
    <section className="py-12 border-t">
      <div className="container">
        <h2 className="font-display text-xl md:text-2xl font-bold text-center mb-2">Our Partners</h2>
        <p className="text-sm text-muted-foreground text-center mb-8">Trusted by Ethiopia's leading banks, developers, and brands.</p>
      </div>
      <div className="overflow-hidden relative">
        <div className="flex gap-10 animate-marquee w-max">
          {items.map((p, i) => (
            <div key={i} className="flex items-center gap-2 px-6 py-3 rounded-lg bg-muted/40 border min-w-max grayscale hover:grayscale-0 transition">
              <Building2 className="h-5 w-5 text-muted-foreground" />
              <span className="text-sm font-semibold text-muted-foreground whitespace-nowrap">{p}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
